import React from "react";
import PriceSettingsTab from "../UsersPage/ViewUser/PriceSettingsTab";
import { ProfileLevels } from "../UsersPage/ViewUser/types";
import Page from "../Page";
import { useUser } from "../../context/UserContext";
import BuyerPricesTable from "./BuyerPricesTable";
import { CNY_TO_USD } from "../../utils/formatters";
import styles from "./styles.module.scss";

interface PriceSettingRow {
  APP_STORE: {
    KEYWORDS: number;
    RATINGS: number;
    REVIEWS: number;
  };
  GOOGLE_STORE: {
    KEYWORDS: number;
    RATINGS: number;
    REVIEWS: number;
  };
}

const initialPriceSettingsData: PriceSettingRow[] = [
  {
    APP_STORE: { KEYWORDS: 0, RATINGS: 0, REVIEWS: 0 },
    GOOGLE_STORE: { KEYWORDS: 0, RATINGS: 0, REVIEWS: 0 },
  },
];

const DefaultPricePage = ({ priceSettings, refetch }: any) => {
  const { user } = useUser();
  // updateDefaultPricing is guarded by JwtSuperAdminStrategy on the backend,
  // so plain admins only see the prices.
  const readOnly = user?.role !== "SUPER_ADMIN";

  if (!priceSettings) return <Page title="Price settings">Loading...</Page>;
  const defaultLimitsByTier: Record<string, { apps: number; keywords: number }> =
    {
      STARTER: { apps: 5, keywords: 500 },
      ADVANCED: { apps: 20, keywords: 1500 },
      EXPERT: { apps: 50, keywords: 4000 },
    };

  const withLimits = (tier: "STARTER" | "ADVANCED" | "EXPERT") => {
    const tierPricing = priceSettings[tier];
    return {
      ...tierPricing,
      LIMITS: tierPricing?.LIMITS ?? defaultLimitsByTier[tier],
    };
  };
  return (
    <Page title="Price settings">
      <section className={styles.tier}>
        <h2 className={styles.tierTitle}>Starter</h2>
        <PriceSettingsTab
          priceSettings={withLimits("STARTER")}
          refetch={refetch}
          profileLevels={ProfileLevels.STARTER}
          readOnly={readOnly}
        />
      </section>
      <section className={styles.tier}>
        <h2 className={styles.tierTitle}>Advanced</h2>
        <PriceSettingsTab
          priceSettings={withLimits("ADVANCED")}
          refetch={refetch}
          profileLevels={ProfileLevels.ADVANCED}
          readOnly={readOnly}
        />
      </section>
      <section className={styles.tier}>
        <h2 className={styles.tierTitle}>Expert</h2>
        <PriceSettingsTab
          priceSettings={withLimits("EXPERT")}
          refetch={refetch}
          profileLevels={"EXPERT"}
          readOnly={readOnly}
        />
      </section>
      {/* What the contractor is paid: a super admin's only, to see too. */}
      {!readOnly && (
        <section className={styles.tier}>
          <h2 className={styles.tierTitle}>
            Contractor prices, ¥{" "}
            <span className={styles.tierRate}>1 USD = {CNY_TO_USD} CNY</span>
          </h2>
          <BuyerPricesTable />
        </section>
      )}
    </Page>
  );
};

export default DefaultPricePage;
